import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const semgrepPlugin = createPlugin({
  id: 'semgrep',
  routes: {
    root: rootRouteRef,
  },
});

export const SemgrepPage = semgrepPlugin.provide(
  createRoutableExtension({
    name: 'SemgrepPage',
    component: () =>
      import('./components/SemgrepComponent').then(m => m.SemgrepComponent),
    mountPoint: rootRouteRef,
  }),
);
